import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BiX } from "react-icons/bi";

const CreateScenarioTooltip = () => {
  const { t } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(true);
  const scenarioTooltipValue = localStorage?.getItem("ShowScenarioTooltip");

  useEffect(() => {
    setShowTooltip(scenarioTooltipValue == "Hide" ? false : true);
  }, [scenarioTooltipValue]);

  const onClose = () => {
    localStorage.setItem("ShowScenarioTooltip", "Hide");
    setShowTooltip(false);
  };
  return showTooltip ? (
    <div className="tw-w-full tw-flex tw-justify-center">
      <div className="tw-w-[21rem] tw-h-16 tw-p-1 tw-bg-white tw-rounded-md tw-border tw-border-solid tw-border-gray-300 tw-justify-start tw-items-start tw-gap-2 tw-inline-flex  tw-drop-shadow-lg tw-absolute tw-top-2 tw-z-40">
        <div className="tw-grow tw-shrink tw-basis-0 tw-h-14 tw-p-2 tw-justify-start tw-items-center tw-gap-2.5 tw-flex">
          <div className="tw-w-10 tw-h-10 tw-relative">
            <div className="tw-w-10 tw-h-10 tw-left-0 tw-top-0 tw-absolute tw-bg-gray-200 tw-rounded-md">
              <img
                className="tw-w-7 tw-h-7 tw-left-[5px] tw-top-[5px] tw-absolute"
                src="https://cdn.1cdn.app/application/LOUISEBOT/25020210141049_louise_drag_drop.png"
              />
            </div>
          </div>
          <div className="tw-grow tw-shrink tw-basis-0 tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
            {t("KnowledgeBasesCreateAssistantBot/text-04")}
          </div>
        </div>
        <div
          onClick={onClose}
          role="button"
          className="tw-p-1 tw-rounded-full tw-justify-start tw-items-center tw-gap-2.5 tw-flex"
        >
          <BiX className="tw-w-6 tw-h-6 tw-relative tw-overflow-hidden" />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CreateScenarioTooltip;
